export default class PositionSettingConfiguration {
    fullContractMinimum: number[] = null;
    miniContractMinimum: number[] = null;
    balance: number[] = null;
}